(() => {
  if (customElements.get('croma-related-products')) return;

  class CromaRelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-loaded') || this.controller || !this.dataset.url) return;
      this.loadRecommendations();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }

    async loadRecommendations() {
      const controller = new AbortController();
      this.controller = controller;
      try {
        const response = await fetch(this.dataset.url, { signal: controller.signal });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = Array.from(html.querySelectorAll('croma-related-products'))
          .find((element) => element.dataset.sectionId === this.dataset.sectionId);
        if (controller.signal.aborted || !this.isConnected) return;
        this.setAttribute('data-loaded', '');
        if (!result?.querySelector('[data-croma-carousel-item]')) return;
        // Reveal before insertion so the carousel measures its visible track.
        this.hidden = false;
        this.replaceChildren(...Array.from(result.childNodes));
      } catch (error) {
        // Empty and failed recommendations must not leave a heading or spacing.
        if (error.name !== 'AbortError') this.hidden = true;
      } finally {
        if (this.controller === controller) this.controller = null;
      }
    }
  }

  customElements.define('croma-related-products', CromaRelatedProducts);
})();
